import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

export const UseFetchCases = (userId) => {
  return useQuery(
    ["getFetchCase"],
    async (value) => {
      try {
        const endpoint = `/api/v1/input/list/case/${userId}`;
        const { result } = await GET(endpoint);
        //const { result } = tableBank
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Input..")
      }
    },
    {
      // คงพฤติกรรมเดิมไว้: list งานเคสยังรีเฟรชตอนกลับเข้าแท็บ (กัน realtime หาย)
      // ชั่วคราวจน Tier B (websocket push 'case:updated') มาแทน
      refetchOnWindowFocus: true,
    }
  );
};

// Hook ใหม่สำหรับนับจำนวนเคส
export const UseFetchCaseCount = (userId) => {
  return useQuery(
    ["getCaseCount", userId],
    async () => {
      try {
        const endpoint = `/api/v1/input/list/case/count/${userId}`;
        const { result } = await GET(endpoint);

        // นับเคสที่มี status เป็น Waiting หรือ Pending
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Case Count..");
      }
    },
    {
      // realtime หลัก: websocket push 'case:updated' invalidate ทันที (ดู App.js)
      // interval นี้เหลือไว้เป็น fallback กรณี socket หลุด/พลาด event
      refetchInterval: 60000, // 60 วิ (ลดจาก 10 วิ)
      refetchIntervalInBackground: false, // ไม่ refetch เมื่อ tab ไม่ active
      staleTime: 30000,
      cacheTime: 60000,
    }
  );
};

export const UseFetchManageCase = () => {
  return useMutation({
    mutationFn: async (value) => {
      const endPoint = `/api/v1/case`;
      // หมายเหตุ: POST(path, obj, token) — arg ที่ 3 คือ token ไม่ใช่ options
      // เดิมส่ง { timeout } ทำให้ Authorization เพี้ยนเป็น [object Object] + timeout ไม่มีผล (POST fix 120s เอง)
      return await POST(endPoint, value);
    },
  });
};

// ไม่กลืน error ภายใน → reject ออกมาเพื่อให้ผู้เรียก (mutateAsync + await) รู้ว่าสำเร็จ/พลาด
export const UseFetchStartCase = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/case/start`, value),
  });
};

// กรอก userId (ลูกค้า) ให้เคสที่ส่งมาแบบ "ไม่มี User"
// ต้องยิง endpoint นี้แยก เพราะตอนกดจบเคส (manageCase) backend เขียนแค่ dataManage ไม่แตะคอลัมน์ userId
export const UseFetchUpdateInputUser = () => {
  return useMutation({
    mutationFn: async ({ id, userId }) => await PUT(`/api/v1/input/${id}/user`, { userId }),
  });
};

export const UseFetchRejectCase = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/input/reject`, value),
  });
};

// ส่งเคสกลับเพื่อขอข้อมูลเพิ่ม — เคสถูกต้อง แต่ข้อมูลไม่พอทำต่อ (ไม่ใช่ความผิดของคนส่ง)
export const UseFetchInformCase = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/input/inform`, value),
  });
};

export const UseFetchPendingCase = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/input/pending`, value),
  });
};

export const UseFetchAssignCase = () => {
  return useMutation({
    mutationFn: async (value) => {
      const endpoint = `/api/v1/input/assign`;
      return await POST(endpoint, value ,{
        timeout: 10000,
      });
    },
  });
};

// รายชื่อผู้ให้บริการสลิปที่ใช้งานได้ของบริษัท (company มาจาก header)
export const UseFetchSlipProviders = (companyId) => {
  return useQuery(
    ["getSlipProviders", companyId],
    async () => {
      const { result } = await GET(`/api/v1/slip/providers`);
      return result;
    },
    { enabled: !!companyId }
  );
};

// ถอด QR จากรูปสลิป (reject เมื่อถอดไม่ได้ เพื่อให้ component แสดง error / fallback กรอกเอง)
export const UseFetchDecodeQr = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/slip/decode-qr`, value),
  });
};

// ส่งสลิปไปยัง provider (reject เมื่อ provider ตอบ fail เพื่อ surface message ของ provider)
export const UseFetchSendSlipDeposit = () => {
  return useMutation({
    mutationFn: async (value) => await POST(`/api/v1/slip/slip-deposit`, value),
  });
};
